/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Invite_AcceptedInputs */

const cs_portal_invite_accepted = /** @type {(inputs: Portal_Invite_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Účet aktivován.`)
};

const en_portal_invite_accepted = /** @type {(inputs: Portal_Invite_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account activated.`)
};

/**
* | output |
* | --- |
* | "Account activated." |
*
* @param {Portal_Invite_AcceptedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_invite_accepted = /** @type {((inputs?: Portal_Invite_AcceptedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Invite_AcceptedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_invite_accepted(inputs)
	return cs_portal_invite_accepted(inputs)
});